import axios from "axios";

export const getRedemptionCode = async (token: string) => {
  return axios.get(process.env["REACT_APP_API_ENDPOINT"]!, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
